import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  updateDomain,
  changeDailyLimit,
  deleteDomain,
  changeDistribution,
  registerNewDomain,
} from '../services/domain-warmup';
import { showSuccessNotification } from '../services/common';

export const useRegisterNewDomain = () => {
  const queryClient = useQueryClient();
  return useMutation(registerNewDomain, {
    onSuccess: async () => {
      await queryClient.invalidateQueries(['domain-warmup']);
      showSuccessNotification('Create domain successfully');
    },
  });
};

export const useUpdateDomain = () => {
  const queryClient = useQueryClient();
  return useMutation(
    ({ domain, data }) => {
      return updateDomain(domain, data);
    },
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries(['domain-warmup']);
        showSuccessNotification('Update domain successfully');
      },
    },
  );
};

export const useChangeDailyLimit = () => {
  const queryClient = useQueryClient();
  return useMutation(
    ({ domain, dailyLimit }) => {
      return changeDailyLimit({
        domains: [domain],
        dailyLimit,
      });
    },
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries(['domain-warmup']);
        showSuccessNotification('Update daily limit successfully');
      },
    },
  );
};

export const useDeleteDomain = () => {
  const queryClient = useQueryClient();
  return useMutation(
    domain => {
      return deleteDomain(domain);
    },
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries(['domain-warmup']);
        showSuccessNotification('Delete domain successfully');
      },
    },
  );
};

export const useChangeDistribution = () => {
  const queryClient = useQueryClient();
  return useMutation(
    distribution => {
      return changeDistribution(distribution);
    },
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries(['domain-warmup']);
        showSuccessNotification('Change distribution successfully');
      },
    },
  );
};
